import { clsx } from 'clsx';
import { IconButton, Icon } from '@hevoio/hevo-ui-toolkit';

interface EntityMenuActionButtonProps {
  target: string;
  disabled?: boolean;
  label: string;
  disabledLabel?: string;
  className?: string;
  onClick: VoidFunction;
  iconSize?: number;
}

export function EntityMenuActionButton({
  target,
  disabled,
  onClick,
  label,
  disabledLabel,
  className,
  iconSize
}: EntityMenuActionButtonProps) {
  return (
    <IconButton
      dataId={target}
      label={disabled ? disabledLabel! : label}
      id={target}
      disabled={disabled}
      onClick={(e: MouseEvent) => {
        e.stopPropagation();
        onClick();
      }}
      className={clsx(className)}
    >
      <Icon name='more-vertical' size={iconSize || 3} dataId={target} />
    </IconButton>
  );
}
